import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full flex justify-end" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "flex items-center text-xl font-bold gap-1 mt-3" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["innerHTML"]

import { onMounted, ref } from "vue"
  import { useRouter } from "vue-router"
  import { useAuthenticationStore } from "@/store/authentication"
  import { checkmarkCircle, heartOutline } from "ionicons/icons"
  import { IonIcon } from "@ionic/vue"
  import follow from "@/utils/follow"
  import { useGtm } from "@gtm-support/vue-gtm"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'DisoverCard',
  props: {
    detail: null,
    discoverType: null
  },
  setup(__props: any) {

const props = __props as {
    detail: {
      slug: string
      image: string
      location: string
      color: string
      logo: string
      name: string
      subtext: string
      follows: string[]
    }
    discoverType: "company" | "job"
  }

  const following = ref(false)
  const router = useRouter()
  const gtm = useGtm()

  

  /**
   * check follow
   * if true then return already follow
   * else follow the job
   */
  const onFollow = () => {
    if (!localStorage.getItem("WBSAASAPP_TK")) useAuthenticationStore().authenticationWall = true
    else if (following.value) follow.alreadyFollowing()
    else {
      follow.followJobOrCompany(props.discoverType, props.detail.slug, gtm)
      following.value = !following.value
    }
  }

  const openJob = (slug: string) => (window.location.href = slug)
  onMounted(async () => {
    following.value = await follow.status(props.discoverType, props.detail.follows, props.detail.follows)
  })

return (_ctx: any,_cache: any) => {
  const _component_ion_label = _resolveComponent("ion-label")!

  return (_openBlock(), _createBlock(_component_ion_label, {
    class: "flex items-center justify-center max-w-[23rem] mx-auto",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (openJob(props.detail.slug)))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_unref(IonIcon), {
          id: "heart_button_company",
          class: "text-white absolute text-3xl bg-primary-black rounded-full px-1 py-1 bg-opacity-20 mt-3 mr-3 cursor-pointer heart-button-favorite",
          icon: _unref(heartOutline),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (onFollow()))
        }, null, 8, ["icon"]),
        _createElementVNode("div", {
          class: "rounded-base h-[330px] w-[23rem] flex flex-col items-center justify-center bg-center bg-cover",
          style: _normalizeStyle({
          backgroundImage: props.detail.image.length ? `url(${props.detail.image})` : props.detail.logo,
          backgroundColor: props.detail.color,
        })
        }, [
          (!props.detail.image.length)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                src: props.detail.logo,
                class: "object-center h-36 object-contain w-36 rounded-3xl overflow-hidden"
              }, null, 8, _hoisted_2))
            : _createCommentVNode("", true)
        ], 4)
      ]),
      _createElementVNode("span", _hoisted_3, [
        _createElementVNode("img", {
          class: "w-8 h-8 rounded-full object-contain",
          src: props.detail.logo,
          alt: ""
        }, null, 8, _hoisted_4),
        _createTextVNode(" " + _toDisplayString(props.detail.name) + " ", 1),
        _createVNode(_unref(IonIcon), {
          class: "text-primary-yellow",
          icon: _unref(checkmarkCircle)
        }, null, 8, ["icon"])
      ]),
      (props.detail.location)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(props.detail.location), 1))
        : _createCommentVNode("", true),
      (props.detail.subtext)
        ? (_openBlock(), _createElementBlock("p", {
            key: 1,
            class: "text-sm font-normal italic",
            innerHTML: props.detail.subtext
          }, null, 8, _hoisted_6))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})